import React, { useState, useEffect } from 'react';
import Toast from '../Layout/Toast';
import './Login.css';

import { authService, companyService } from '../../services/api';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: 'admin',
    password: 'admin'
  });
  const [error, setError] = useState('');
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [branding, setBranding] = useState({
    name: 'Record & Stock Management System',
    logo: '/logo.png'
  });

  useEffect(() => {
    const fetchBranding = async () => {
      try {
        const response = await companyService.getBranding();
        if (response.data) {
          setBranding({
            name: response.data.name || 'Record & Stock Management System',
            logo: response.data.logo || '/logo.png'
          });
        }
      } catch (err) {
        console.error('Failed to fetch branding:', err);
      }
    };
    fetchBranding();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await authService.login(formData);

      setShowSuccessToast(true);
      setError('');

      // Show toast for 1 second, then trigger login logic
      setTimeout(() => {
        // Pass the user object and token from backend response
        onLogin(response.data.user, response.data.token);
      }, 1000);

    } catch (err) {
      console.error('Login error:', err);
      // Try to get error message from backend
      const errMsg = err.response?.data?.error || 'Invalid username or password. Please try again.';
      setError(errMsg);
      setShowErrorToast(true);
    }
  };

  return (
    <div className="login-container">
      {showSuccessToast && (
        <Toast
          message="Welcome to RSMS!"
          type="success"
          duration={2000}
          onClose={() => setShowSuccessToast(false)}
        />
      )}
      {showErrorToast && (
        <Toast
          message="Invalid username or password. Please check your credentials."
          type="error"
          duration={4000}
          onClose={() => setShowErrorToast(false)}
        />
      )}
      <div className="login-card">
        <div className="login-header">
          <div className="text-center mb-4">
            <img
              src={branding.logo}
              alt="Company Logo"
              style={{ height: '120px', width: 'auto', marginBottom: '20px' }}
            />
          </div>
          <p className="mb-0 fw-bold">Record & Stock Management System</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Username</label>
            <input
              type="text"
              className="form-control"
              value={formData.username}
              onChange={(e) => {
                setFormData({ ...formData, username: e.target.value });
                setError('');
              }}
              required
              placeholder="Enter your username"
              autoFocus
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              value={formData.password}
              onChange={(e) => {
                setFormData({ ...formData, password: e.target.value });
                setError('');
              }}
              required
              placeholder="Enter your password"
            />
          </div>
          {error && (
            <div className="alert alert-danger" role="alert">
              <i className="bi bi-exclamation-triangle"></i> {error}
            </div>
          )}
          <div className="mb-3 form-check">
            <input type="checkbox" className="form-check-input" id="remember" />
            <label className="form-check-label" htmlFor="remember">
              Remember me
            </label>
          </div>
          <button type="submit" className="btn btn-primary w-100 mb-4">
            <i className="bi bi-box-arrow-in-right"></i> Login
          </button>

          <div className="login-footer text-center border-top pt-3">
            <p className="text-muted mb-0" style={{ fontSize: '0.8rem' }}>
              &copy; {new Date().getFullYear()} <a href="https://cubetechwiz.com/" target="_blank" rel="noopener noreferrer" className="text-muted text-decoration-none fw-bold">Cube Techwiz</a>. All Rights Reserved.
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
